import { UserService } from './../../../../core/services/user.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserRoleNames, Users } from 'src/app/core/models/users';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserGroups } from '../../../../core/models/user';
import { GroupsService } from '../../../../core/services/groups.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/modules/shared/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss'],
})
export class UserDetailsComponent implements OnInit, OnDestroy {
  depName: string;
  userName: string;
  loaded: boolean;
  users: Users;
  multipleEmailIds = [];
  authType: string;
  getUserDetailsSub: Subscription;
  currentUserRole: string = this.authenticationService.getRole() || '';
  loggedInUser: string = this.authenticationService.getLoggedInUserFromLocalStorage();
  isMonitor: boolean = this.authenticationService.currentUserValue.role == UserRoleNames.Reader ? true : false;
  userGroup: UserGroups = null
  constructor(
    private _groupsService: GroupsService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private spinner: NgxSpinnerService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
  ) { }
  ngOnDestroy(){
    this.getUserDetailsSub.unsubscribe()
  }
  ngOnInit(): void {
    this.depName =
      this.route.snapshot.params['deploymentName'] ||
      this.route.parent.snapshot.params['deploymentName'];
    this.getUserDetailsSub = this.userService.userName.subscribe((x) => {
      this.userName = x;
      this.multipleEmailIds = []
      this.loadUserDetails();
      this.loadUserGroupDetails()
    });
    this.spinner.hide("userList");
  }

  loadUserDetails(){
    this.spinner.show("userDetailsLoad");
    this.userService
      .getUserDetails(this.userName)
      .subscribe((data) => {
        this.users = <Users>JSON.parse(JSON.stringify(data));
        this.userService.updateUserDetails(this.users)
        if(this.users.emailId && this.users.emailId.includes(',')){
          this.multipleEmailIds = this.users.emailId.split(',');
        }
        this.spinner.hide("userDetailsLoad");
        this.loaded = true;
      });
  }

  loadUserGroupDetails() {
    this.userService.getUserSpecificGroups(this.userName).subscribe({
      next: (data) => {
        console.log("userGroup")
        this.userGroup = <UserGroups>JSON.parse(JSON.stringify(data));
      },
      error: (err) => {
        console.log(err)
      }
    })
  }

  removeUser(groupName) {
    try {
      let userObject = [{
        name: this.userName, isSelected: false
      }]
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: "50%",
        autoFocus: false,
        disableClose: false,
        data: {
          titleMessage: 'Remove User From Group',
          bodyMessage: `Do you want to remove ${this.userName} from group ${groupName}?`,
          cancelText: "No",
          submitText: "Yes",
        }
      });
      dialogRef.afterClosed().subscribe((confirmed) => {
        if (confirmed) {
          this.spinner.show("userDetailsLoad");
          this._groupsService
            .updateUsersInGroup(groupName, userObject)
            .subscribe({
              next: (data: any) => {
                this.spinner.hide("userDetailsLoad");
                this.snackBar.open(data?.actionMessage, 'Ok', {
                  duration: 3000
                });
              },
              error: (err: any) => {
                this.spinner.hide("userDetailsLoad");
                this.snackBar.open(err?.error?.actionMessage, 'Ok', {
                  duration: 3000
                });
              },
            });
        }
      });
    }
    catch (err) {
      this.spinner.hide("userDetailsLoad");
      console.error('Error removing user from group:', err);
      this.snackBar.open('Error removing user from group', 'Ok', {
        duration: 3000
      });
      return;
    }
  }
}

